export default __webpack_public_path__ + "static/subMenuBlog-f56504a9fb4267e2e9a4e62f560b74f9.svg";